import ChartOutlineIcon from '@/assets/icons/chart-outline.svg';
import InformOutlineIcon from '@/assets/icons/inform-outline.svg';
import LeaderboardOutlineIcon from '@/assets/icons/leaderboard-outline.svg';
import VisionOutlineIcon from '@/assets/icons/vision-outline.svg';
import TicketOutlineIcon from '@/assets/icons/ticket-outline.svg';
import ManagePeopleOutlineIcon from '@/assets/icons/manage-people-outline.svg';
import PlanOutlineIcon from '@/assets/icons/plan-outline.svg';
import DriverOutlineIcon from '@/assets/icons/driver-outline.svg';
import SearchOutlineIcon from '@/assets/icons/search-outline.svg';
import SettingOutlineIcon from '@/assets/icons/setting-outline.svg';
// import ServiceNowIcon from '@/assets/icons/service-now.svg';
import LinkOutLineIcon from '@/assets/icons/link-outline.svg';
import { getPidMcsMenu } from '@/modules/pid-cms/commons/menu';
export var getMenu = function (translate) { return [
    {
        label: translate('dashboard'),
        items: [
            {
                id: 'dashboard',
                path: '/',
                label: translate('dashboard'),
                icon: LeaderboardOutlineIcon,
            },
        ],
    },
    {
        label: translate('applications'),
        items: [
            {
                id: 'mobility_driver',
                label: translate('driver'),
                icon: DriverOutlineIcon,
                path: process.env.APPLICATIONS_DRIVER_SUPPORT,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_analyse',
                label: translate('analyse'),
                icon: ChartOutlineIcon,
                path: process.env.APPLICATIONS_ANALYSIS,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_manage',
                label: translate('manage'),
                icon: ManagePeopleOutlineIcon,
                path: process.env.APPLICATIONS_OPERATIONS,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_plan',
                label: translate('plan'),
                icon: PlanOutlineIcon,
                path: process.env.APPLICATIONS_PLANNING,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_vision',
                label: translate('vision'),
                icon: VisionOutlineIcon,
                path: process.env.APPLICATIONS_DETECTION,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_inform',
                label: translate('inform'),
                icon: InformOutlineIcon,
                underline: false,
                openInNew: false,
                children: getPidMcsMenu(translate),
            },
            {
                id: 'mobility_ticket',
                label: translate('ticket'),
                icon: TicketOutlineIcon,
                path: process.env.APPLICATIONS_TICKETING,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_maas',
                label: translate('maas'),
                icon: SettingOutlineIcon,
                path: process.env.APPLICATIONS_MAAS,
                underline: false,
                openInNew: true,
            },
            {
                id: 'mobility_inspect',
                label: translate('inspect'),
                icon: SearchOutlineIcon,
                path: process.env.APPLICATIONS_INSPECTION,
                underline: false,
                openInNew: true,
            },
            // {
            //   id: 'mobility_serviceNow',
            //   label: translate('serviceNow'),
            //   icon: ServiceNowIcon,
            //   path: '/a',
            //   underline: false,
            //   openInNew: true,
            // },
        ],
    },
    {
        label: translate('other'),
        items: [
            {
                id: 'useful_links',
                label: translate('usefulLinks'),
                icon: LinkOutLineIcon,
                path: '/a',
            },
        ],
    },
]; };
